<ng-container *ngIf="!hide">
    <div *ngIf="!isStaff" class="shieldCircle" [matTooltip]="isOnline? 'Online':'Offline'"
         [class.isOnline]="isOnline">
    </div>
    <div *ngIf="isStaff" class="shieldCircle" [matTooltip]="isOnline? 'Moderator, Online':'Moderator, Offline'"
         [class.isOnline]="isOnline">
        <mat-icon>verified_user</mat-icon>
    </div>
</ng-container>

<ng-container *ngIf="hide && isStaff">
    <div *ngIf="isStaff" class="shieldCircle" [matTooltip]="'Moderator'">
        <mat-icon>verified_user</mat-icon>
    </div>
</ng-container>
